import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import cn from 'classnames';
import Tooltip, { InfoPropTypes } from 'components/Tooltip';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(theme => ({
  formControl: {
    display: 'flex',
    color: theme.palette.text.primary,
  },
  label: {
    display: 'flex',
    color: theme.palette.text.primary,
  },
  root: {
    '& .MuiIconButton-label': {
      color: theme.palette.primary.light,
    },
  },
}));

export default function RadioButtonsGroup({
  onChange: handleChange,
  label,
  value,
  options,
  info,
  error,
  item,
  classNames,
  disabled,
}) {
  const classes = useStyles();
  const onChange = event => {
    const radioVal = event.target.value;
    if (item?.valueType === 'object') {
      const g = options.find(f => f.value === radioVal);
      handleChange(g);
      return;
    }
    handleChange(radioVal);
  };
  return (
    <FormControl component="fieldset" className={classes.formControl}>
      <InputLabel shrink className={cn(classes.label, classes.input)}>
        {label}
        {info && <Tooltip text={info} />}
      </InputLabel>
      <RadioGroup
        aria-label={item.field}
        name={item.field}
        value={value.value} // value is an object
        row
        onChange={onChange}
        classes={{ row: classNames, root: classes.root }}
      >
        {options.map((opt, key) => (
          <FormControlLabel
            key={key}
            value={opt.value}
            control={<Radio disableRipple checked={value[opt.value]} />}
            label={opt.id}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
      {error && (
        <FormHelperText id="component-error-text" error={Boolean(error)}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}

RadioButtonsGroup.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  info: InfoPropTypes,
  error: PropTypes.string,
  classNames: PropTypes.string,
  item: PropTypes.object,
};
